module.exports = __webpack_public_path__ + "static/media/symbol-defs.07fafb39.svg";